import { HANDLE_MAINTENANCE_MODE } from "./constants";

const initialState = {
  isMaintenance: false,
};

export function reducer( state = initialState,  { type, isMaintenance }) {
  switch (type) {
    case HANDLE_MAINTENANCE_MODE:
      return {
        ...state, isMaintenance: isMaintenance
      };
    default:
      return state;
  }
}
